module.exports = __webpack_public_path__ + "static/media/arrow-left-translucent.00072b8f.png";